import { render, staticRenderFns } from "./TinySauce.vue?vue&type=template&id=477526f6"
import script from "./TinySauce.vue?vue&type=script&lang=js"
export * from "./TinySauce.vue?vue&type=script&lang=js"
import style0 from "./TinySauce.vue?vue&type=style&index=0&id=477526f6&prod&lang=scss&module=true"
import style1 from "./TinySauce.vue?vue&type=style&index=1&id=477526f6&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports